// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#adminApp .application {
  font-family: var(--font-family);
}
.theme--light.v-card, .v-card {
  background-color: var(--panel-background);
}
.theme--light.application {
  background-color: var(--background--color) !important;
}
table.v-table tbody td {
  font-size: 11px !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
}
table.v-table thead th {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.v-datatable__actions {
  flex-wrap: nowrap !important;
}
.v-datatable__actions__pagination {
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./js/modules/admin/components/App/App.vue","webpack://./App.vue"],"names":[],"mappings":"AACE;EACE,+BAAA;ACAJ;ADGE;EACE,yCAAA;ACAJ;ADGE;EACE,qDAAA;ACAJ;ADGE;EACE,0BAAA;EACA,4BAAA;EACA,6BAAA;ACAJ;ADGA;EACI,4BAAA;EACA,6BAAA;ACAJ;ADGA;EACI,4BAAA;ACAJ;ADGA;EACI,mBAAA;ACAJ","sourcesContent":["\n  #adminApp .application {\n    font-family: var(--font-family);\n  }\n\n  .theme--light.v-card, .v-card {\n    background-color: var(--panel-background);\n  }\n\n  .theme--light.application {\n    background-color: var(--background--color)!important\n  }\n\n  table.v-table tbody td {\n    font-size: 11px!important;\n    padding-left: 4px!important;\n    padding-right: 4px!important;\n    }\n\ntable.v-table thead th {\n    padding-left: 4px!important;\n    padding-right: 4px!important;\n    }\n\n.v-datatable__actions {\n    flex-wrap: nowrap!important;\n}\n\n.v-datatable__actions__pagination {\n    white-space: nowrap;\n}\n  ","#adminApp .application {\n  font-family: var(--font-family);\n}\n\n.theme--light.v-card, .v-card {\n  background-color: var(--panel-background);\n}\n\n.theme--light.application {\n  background-color: var(--background--color) !important;\n}\n\ntable.v-table tbody td {\n  font-size: 11px !important;\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n\ntable.v-table thead th {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n\n.v-datatable__actions {\n  flex-wrap: nowrap !important;\n}\n\n.v-datatable__actions__pagination {\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
